import styled from 'styled-components';

export const MobileSafeArea = styled('div')`
  padding-top: ${({ theme }) => theme.safeAreaInsetTop};
  padding-bottom: ${({ theme }) => theme.safeAreaInsetBottom};
`;
